import useAppSelector from 'hooks/useAppSelector';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';
import { WITHDRAWAL_ROUTES } from 'utils/withdrawalRoutes';

type WithdrawalLinkProps = {
    className?: string;
    onClick?: () => void;
    navigation?: boolean;
};

// Entry point to the right-of-withdrawal function. It renders nothing unless the shop has the function enabled,
// which the anonymous init payload tells us before any password or login wall.
const WithdrawalLink = ({ className, onClick, navigation = false }: WithdrawalLinkProps) => {
    const { t } = useTranslation();
    const enabled = useAppSelector(({ shop }) => shop.info?.withdrawalEnabled === true);

    if (!enabled) return null;

    return (
        <StyledLink to={WITHDRAWAL_ROUTES.lookup} className={className} onClick={onClick} $navigation={navigation}>
            {t('withdrawal_nav')}
        </StyledLink>
    );
};

const StyledLink = styled(Link)<{ $navigation: boolean }>`
    white-space: nowrap;
    text-decoration: underline;
    ${({ $navigation, theme }) =>
        $navigation
            ? `
        color: ${theme.mainTextColor};
        &:hover, &:focus, &:visited { color: ${theme.mainTextColor}; }
    `
            : ''}
`;

export default WithdrawalLink;
